import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent, isValidElement } from 'react';
import classnames from 'classnames';
import Spin from '../Spin';
import Group from './Group';
import Once from './Once';
import { wrapSpan } from '../utils/dom/element';
import { buttonClass } from './styles';
import { isRTL } from '../config';
import { getDirectionClass } from '../utils/classname';
var DefaultProps = {
  size: 'default',
  htmlType: 'button',
  outline: false,
  type: 'default'
};

var Button =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Button, _PureComponent);

  var _super = _createSuper2(Button);

  function Button() {
    _classCallCheck(this, Button);

    return _super.apply(this, arguments);
  }

  _createClass(Button, [{
    key: "getChildren",
    value: function getChildren() {
      var _this$props = this.props,
          children = _this$props.children,
          loading = _this$props.loading,
          space = _this$props.space;
      if (!children) return children;
      var parsed = React.Children.map(wrapSpan(children, space), function (item) {
        if (loading &&
        /*#__PURE__*/
        isValidElement(item) && item.type.isShineoutIcon) return null;
        return item;
      });
      return (parsed || []).filter(function (v) {
        return v !== null;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          outlineProp = _this$props2.outline,
          typeProp = _this$props2.type,
          size = _this$props2.size,
          href = _this$props2.href,
          htmlType = _this$props2.htmlType,
          loading = _this$props2.loading,
          disabled = _this$props2.disabled,
          onRef = _this$props2.onRef,
          shape = _this$props2.shape,
          text = _this$props2.text,
          space = _this$props2.space,
          target = _this$props2.target,
          others = _objectWithoutProperties(_this$props2, ["outline", "type", "size", "href", "htmlType", "loading", "disabled", "onRef", "shape", "text", "space", "target"]);

      var isSecondary = typeProp === 'secondary' && !outlineProp && !text;
      var type = isSecondary ? 'primary' : typeProp;
      var outline = outlineProp || isSecondary;
      var color = outline || type === 'default' ? undefined : '#fff';
      if (text) color = 'currentColor';
      var className = classnames(buttonClass('_', shape !== 'default' && shape, type, outline && 'outline', {
        large: size === 'large',
        small: size === 'small',
        text: text && 'text',
        rtl: isRTL(),
        disabled: disabled
      }), this.props.className);

      if (href && !disabled) {
        return (
          /*#__PURE__*/
          React.createElement("a", Object.assign({
            href: href
          }, others, {
            target: target,
            className: className,
            ref: onRef
          }), this.props.children)
        );
      }

      var children = this.getChildren();
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/button-has-type
        React.createElement("button", Object.assign({}, others, {
          ref: onRef,
          disabled: disabled || loading,
          type: htmlType,
          className: className
        }), loading &&
        /*#__PURE__*/
        React.createElement("span", {
          className: buttonClass(getDirectionClass('spin'))
        },
        /*#__PURE__*/
        React.createElement(Spin, {
          size: 12,
          name: "ring",
          color: color
        })), children)
      );
    }
  }]);

  return Button;
}(PureComponent);

Button.displayName = 'ShineoutButton';
Button.Group = Group;
Button.Once = Once;
Button.defaultProps = DefaultProps;
export default Button;